var _defs, _path, _g, _g2, _path2, _g3, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevrolet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "chevrolet",
    width: 76.425,
    height: 32.254,
    viewBox: "0 0 76.425 32.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ccc}.cls-2{fill:#e3e3e3}.cls-3{fill:#a6a6a6}.cls-4{fill:#8c8c8c}.cls-5{fill:#f3db53}.cls-6{fill:#f3c153}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_319",
    d: "M76.425 167.188a.694.694 0 0 1-.043.244l-.025.058-8.1 17.888a.644.644 0 0 1-.1.146.594.594 0 0 1-.1.091.5.5 0 0 1-.29.093H53.058a.6.6 0 0 0-.515.31.766.766 0 0 0-.106.391v5.217a.666.666 0 0 1-.163.443.523.523 0 0 1-.393.184H24.543a.524.524 0 0 1-.393-.184.667.667 0 0 1-.163-.443v-5.217a.688.688 0 0 0-.472-.68.532.532 0 0 0-.149-.021H.556a.544.544 0 0 1-.473-.3.672.672 0 0 1-.083-.328.7.7 0 0 1 .043-.244l.025-.058 8.106-17.89a.675.675 0 0 1 .1-.144.53.53 0 0 1 .1-.091.514.514 0 0 1 .292-.093h14.7a.591.591 0 0 0 .439-.205.747.747 0 0 0 .182-.5v-5.232a.666.666 0 0 1 .163-.443.525.525 0 0 1 .393-.184h27.339a.525.525 0 0 1 .393.184.624.624 0 0 1 .124.216.685.685 0 0 1 .039.228v5.232a.756.756 0 0 0 .106.391.607.607 0 0 0 .515.309H75.87a.522.522 0 0 1 .393.184.638.638 0 0 1 .081.116.673.673 0 0 1 .081.332z",
    className: "cls-1",
    "data-name": "Trazado 319",
    transform: "translate(0 -159.999)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_153",
    "data-name": "Grupo 153",
    transform: "translate(23.516 .184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_320",
    d: "M162.178 284.936l.182 6.34-3.4 3.854-.784.889a.666.666 0 0 1-.163-.443v-5.217a.688.688 0 0 0-.472-.68z",
    className: "cls-2",
    "data-name": "Trazado 320",
    transform: "translate(-157.543 -264.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_321",
    d: "M164.014 165.838l-.182 6.354-4.345-4.924a.747.747 0 0 0 .182-.5v-5.232a.666.666 0 0 1 .163-.443l.784.889z",
    className: "cls-2",
    "data-name": "Trazado 321",
    transform: "translate(-159.197 -161.096)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_154",
    "data-name": "Grupo 154",
    transform: "translate(24.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_322",
    d: "M189.919 160.184l-.784.889-3.4 3.854h-19.758l-3.4-3.854-.784-.889a.525.525 0 0 1 .393-.184h27.338a.525.525 0 0 1 .395.184z",
    className: "cls-3",
    "data-name": "Trazado 322",
    transform: "translate(-161.795 -160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_323",
    d: "M189.918 327.416a.523.523 0 0 1-.393.184h-27.337a.524.524 0 0 1-.393-.184l.784-.889 3.4-3.854h19.759l3.4 3.854z",
    className: "cls-3",
    "data-name": "Trazado 323",
    transform: "translate(-161.795 -295.347)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_324",
    d: "M11.012 204.511l-4.061 9.1-5.918 4.1-.94.652a.671.671 0 0 1-.093-.326.7.7 0 0 1 .043-.244l.025-.058 8.106-17.89a.675.675 0 0 1 .1-.144.531.531 0 0 1 .1-.091l.577 1.071z",
    className: "cls-2",
    "data-name": "Trazado 324",
    transform: "translate(0 -192.956)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_155",
    "data-name": "Grupo 155",
    transform: "translate(48.092 .184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_325",
    d: "M449.058 201.169a.694.694 0 0 1-.043.244l-.025.058-8.1 17.888a.643.643 0 0 1-.1.145.591.591 0 0 1-.1.091l-.576-1.069-2.1-3.893 4.093-9.037 5.921-4.1.947-.656a.674.674 0 0 1 .083.329z",
    className: "cls-4",
    "data-name": "Trazado 325",
    transform: "translate(-420.725 -194.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_326",
    d: "M326.637 167.162s-4.125 4.735-4.153 4.735a1.739 1.739 0 0 0-.3.188v-6.249l4.182-4.742.124.216a.685.685 0 0 1 .039.228v5.232a.755.755 0 0 0 .108.392z",
    className: "cls-4",
    "data-name": "Trazado 326",
    transform: "translate(-322.186 -161.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_327",
    d: "M326.637 291.138a.765.765 0 0 0-.106.391v5.217a.666.666 0 0 1-.163.443l-4.182-4.742v-6.1h.338z",
    className: "cls-4",
    "data-name": "Trazado 327",
    transform: "translate(-322.186 -265.304)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_328",
    d: "M108.588 195.682l-3.763 8.305a.617.617 0 0 1-.553.382H87.984a.665.665 0 0 0-.621.7v5.143a.665.665 0 0 1-.621.7h-18.88a.665.665 0 0 1-.621-.7v-5.142a.665.665 0 0 0-.621-.7H46.57a.7.7 0 0 1-.553-1.021l3.763-8.305a.617.617 0 0 1 .553-.382h16.288a.665.665 0 0 0 .621-.7V188.8a.665.665 0 0 1 .621-.7h18.88a.665.665 0 0 1 .621.7v5.157a.665.665 0 0 0 .621.7h20.051a.7.7 0 0 1 .552 1.025z",
    className: "cls-5",
    "data-name": "Trazado 328",
    transform: "translate(-39.09 -183.381)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_329",
    d: "M77.3 188.1v22.812h-9.44a.665.665 0 0 1-.621-.7v-5.143a.665.665 0 0 0-.621-.7H46.57a.7.7 0 0 1-.553-1.021l3.763-8.305a.617.617 0 0 1 .553-.382h16.288a.665.665 0 0 0 .621-.7V188.8a.665.665 0 0 1 .621-.7z",
    className: "cls-6",
    "data-name": "Trazado 329",
    transform: "translate(-39.09 -183.38)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevrolet);
export default __webpack_public_path__ + "static/media/chevrolet.77ea560c5956dbaf255b582ced79d975.svg";
export { ForwardRef as ReactComponent };